import { useQuery } from '@apollo/client';
import { DeviceHub } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { NetworkDeviceGroupAuditLogsDocument } from '../queries/AuditLogs.generated';
import { useTabs } from './lib/tabs';

export const DeviceGroupAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ deviceGroupId: string }>();
  const deviceGroupId = parseInt(params.deviceGroupId ?? '');

  const tabs = useTabs();

  const { currentNetwork } = useAppContext();
  const link = useLink();

  const { data, loading } = useQuery(NetworkDeviceGroupAuditLogsDocument, {
    variables: { networkId: currentNetwork.id, deviceGroupId },
  });

  const deviceGroup = data?.network?.deviceGroup;

  if (loading || !deviceGroup)
    return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<DeviceHub />}
        titleText={deviceGroup.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs} />

      <PageContainer>
        <AuditLogList recordTypes={['DeviceGroup']} deviceGroupId={deviceGroupId} />
      </PageContainer>
    </>
  );
};
